
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33838',
  depVersions: {
  "documents-public-ui": "static-1.33838",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33843",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1872",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5339",
  "hs-test-utils": "static-1.7750",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11170",
  "I18n": "static-7.1555",
  "jasmine-immutable": "static-1.2767",
  "jasmine-runner": "static-1.6219",
  "lodash": "static-1.3",
  "quartz": "static-1.6657",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16387",
  "reporting-data": "static-1.66299",
  "reporting-testing-lib": "static-1.8232",
  "reporting-visualizations": "static-1.58375",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4510",
  "webpack-env": "static-1.54",
  "atom": "static-1.4819",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2230",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.715",
  "customer-data-filters-ui": "static-1.38689",
  "customer-data-objects": "static-1.7386",
  "customer-data-property-utils": "static-1.7820",
  "data-fetching-client": "static-1.9425",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4280",
  "flux-actions": "static-1.302",
  "FormsCommonComponents": "static-1.85161",
  "FormUrlGenerator": "static-2.4479",
  "foundations-components": "static-1.7419",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3873",
  "HubStyle": "static-2.11478",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6909",
  "metrics-js": "static-1.9346",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3608",
  "property-translator": "static-1.5162",
  "quartz-config": "static-1.435",
  "quartz-core": "static-1.5876",
  "quick-fetch": "static-1.3684",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5129",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7908",
  "reference-resolvers-lite": "static-1.7839",
  "report-customization-components": "static-1.12345",
  "reporting-enablement": "static-1.21892",
  "reporting-reports": "static-1.65977",
  "reporting-snowflake": "static-1.54917",
  "reporting-ui-components": "static-2.63571",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4378",
  "sales-content-partitioning": "static-1.8683",
  "SalesContentIndexUI": "static-3.8817",
  "sanitize": "static-1.4223",
  "sanitize-text": "static-1.7888",
  "self-service-api": "static-1.9994",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1498",
  "signup-constants": "static-1.18283",
  "signup-ui-lego-core": "static-1.20293",
  "signup-ui-url-generator": "static-2.7806",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4520",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10743",
  "ui-addon-i18n": "static-1.10879",
  "ui-addon-react-router-dom": "static-1.9295",
  "ui-addon-upgrades": "static-9.17553",
  "ui-asset-management-lib": "static-1.10631",
  "ui-images": "static-2.1076",
  "UIComponents": "static-3.8117",
  "usage-tracker": "static-1.7082",
  "usage-tracker-container": "static-1.7072",
  "usage-tracker-core": "static-1.6932",
  "usage-tracker-public": "static-1.6893",
  "viral-links-lib": "static-1.6773",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3181",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2934",
  "quartz-webpack": "static-1.2881",
  "ai-components-ui-library": "static-1.8206",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4580",
  "foundations-theming": "static-1.4156",
  "quartz-auth": "static-1.332",
  "usage-tracker-session-replay": "static-1.4768",
  "foundations-theming-base": "static-1.3141",
  "HeadJS": "static-2.701",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2861",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4079",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7675",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3451",
  "reporting-client-types": "static-1.2368",
  "hs-story-utils": "static-1.9176",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9348",
  "hubspotter-http": "static-1.4433",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6997",
  "crm-message-bus": "static-1.42191",
  "customer-data-filters-ui-msw-helpers": "static-1.21123",
  "customer-data-objects-ui-components": "static-1.12751",
  "customer-data-reference-ui-components": "static-1.12888",
  "customer-data-ui-utilities": "static-1.9573",
  "framework-builder-read-service-client": "static-1.3802",
  "framework-data-schema-quick-fetch": "static-1.6522",
  "framework-data-schema-resolvers": "static-1.6617",
  "inbound-db-properties-service-client": "static-1.3633",
  "multi-account-reference-resolvers": "static-1.717",
  "onboarding-tours": "static-1.16190",
  "reporting-datasets-permissions-lib": "static-1.12895",
  "ui-addon-teams": "static-1.21160",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67468",
  "customer-data-properties": "static-1.50608",
  "forms-ai-lib": "static-1.3934",
  "forms-utils-lib": "static-1.12070",
  "foundations-components-test-utils": "static-1.4902",
  "react-dnd-compat": "static-1.4372",
  "react-tinymce": "static-1.54483",
  "tinymce-config": "static-2.53609",
  "ui-gdpr-components": "static-1.10095",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3689",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1059",
  "ui-fonts": "static-1.432",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.783",
  "mobile-manifest-mixins": "static-1.474",
  "quartz-head": "static-1.322",
  "quartz-i18n": "static-1.332",
  "quartz-routing": "static-1.87",
  "quartz-test": "static-1.332",
  "batch-promise": "static-1.1294",
  "external-options-client-types": "static-1.3938",
  "react-colorpicker": "static-2.9960",
  "copilot-toolkit": "static-1.10392",
  "data-quality-ui-library": "static-1.12197",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40493",
  "reporting-insights-lib": "static-1.1005",
  "reporting-plugins": "static-1.9917",
  "ui-addon-draggable-compat": "static-2.4002",
  "ui-addon-opt": "static-4.8136",
  "ui-shepherd-react": "static-3.9892",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24572",
  "hubspot-apollo-client": "static-1.4628",
  "sales-templates-service-types-lib": "static-1.3948",
  "ui-business-units-lib": "static-1.8770",
  "merchandise-lib": "static-1.256",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5391",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3859",
  "upgrade-management-service-types": "static-1.4256",
  "timezone-utils": "static-2.4992",
  "bender-build-tools": "static-1.2867",
  "chatspot-core": "static-1.20111",
  "chirp-fetch": "static-1.1630",
  "bend-plugin-foundations-theming": "static-1.2639",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9346",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3578",
  "crm-pipelines-api-client-types": "static-1.3919",
  "multi-currency-client-types": "static-1.3473",
  "getting-started-shared-tasks": "static-1.17731",
  "growth-data-modal": "static-1.5099",
  "growth-onboarding-confetti": "static-1.2815",
  "growth-onboarding-next-action-utils": "static-1.1243",
  "navigation-components": "static-1.17106",
  "onboarding-tours-client": "static-1.4404",
  "onboarding-tours-utils": "static-1.256",
  "ui-shepherd-tracker": "static-1.7273",
  "ui-universal-auth": "static-1.8624",
  "user-context": "static-1.4843",
  "cms-field-types": "static-1.4555",
  "content-icons-ui": "static-1.2135",
  "integrations-lib": "static-1.15250",
  "calling-global-api": "static-1.63498",
  "calling-internal-common": "static-1.31040",
  "calling-lifecycle-internal": "static-1.64880",
  "calling-lifecycle-messages": "static-1.57174",
  "commerce-products-lib": "static-1.8687",
  "crm-links": "static-1.6000",
  "file-manager-components": "static-1.22731",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.417",
  "inbounddb-objects-service-types": "static-1.4005",
  "meetings-icalendar-utils-lib": "static-1.382",
  "object-builder-ui-client": "static-1.47800",
  "pipeline-validation-client-types": "static-1.3742",
  "property-value-citations": "static-1.1222",
  "pulse": "static-1.249",
  "smart-property-lib": "static-1.5695",
  "tiered-pricing": "static-1.744",
  "ui-addon-iframeable": "static-1.8785",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19385",
  "tinymce-themes": "static-1.55579",
  "data-token-picker": "static-1.15963",
  "hub-http-contrib": "static-1.2793",
  "interframe": "static-3.4540",
  "tinymce-data": "static-1.39694",
  "tinymce-plugins": "static-1.56723",
  "ui-addon-sales-email": "static-1.4961",
  "magpie-lib": "static-1.5339",
  "magpie-types": "static-1.4799",
  "simple-logging-lib": "static-1.2799",
  "content-assistance-lib": "static-1.7373",
  "dashboard-lib": "static-1.80399",
  "ExportDialog": "static-6.10136",
  "hubspot-prosemirror": "static-1.17455",
  "hubspot-prosemirror-plugins": "static-1.17447",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8438",
  "campaign-roi-lib": "static-1.8124",
  "feedback-loader": "static-1.28758",
  "onboarding-scopes": "static-1.6209",
  "apollo-link-hub-http": "static-2.4397",
  "hubspot-apollo-cache": "static-1.87",
  "growth-monetization-service-types": "static-1.4272",
  "nav-client-types": "static-1.2100",
  "purchase-motions-api": "static-1.5394",
  "trials-service-types": "static-1.3673",
  "chatspot-client-types": "static-1.10412",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.474",
  "getting-started-shared-tasks-store": "static-1.16849",
  "integrations-error-boundary-lib": "static-1.12665",
  "integrations-tracking-lib": "static-1.5332",
  "native-integrations-shared-strings": "static-1.7537",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10121",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31046",
  "shared-worker-versioning": "static-1.10783",
  "calling-usage-tracker": "static-1.6287",
  "voice-sms-access-library": "static-1.82",
  "customer-data-tracking": "static-1.6626",
  "products-iframe-lib": "static-1.7179",
  "products-ui-components-shared-msw-handlers": "static-1.9730",
  "location-customization-utils-lib": "static-1.8390",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3903",
  "video-components-external": "static-1.10408",
  "video-data-lib": "static-1.34066",
  "directed-graph": "static-1.684",
  "event-emitter": "static-1.692",
  "breeze-intelligence-kit": "static-1.5243",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9431",
  "fsm": "static-1.3480",
  "policy-lib": "static-1.6538",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9494",
  "navigation-messaging": "static-1.6433",
  "FileManagerLib": "static-1.38371",
  "NamespacedHubStyle": "static-2.8852",
  "FileManagerCore": "static-1.38230",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11941",
  "layout-dnd-utils": "static-1.10916",
  "react-codemirror": "static-1.10372",
  "ui-addon-emoji-picker": "static-1.9638",
  "ui-brand-identity-lib": "static-1.13615",
  "ui-addon-video-player": "static-1.8443",
  "ui-coaching-tips": "static-1.27800",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8314",
  "payment-link-components": "static-1.22786",
  "EmailSignatureEditor": "static-1.23854",
  "eligibility-engine-service-types": "static-1.2954",
  "universal-page-editor-lib": "static-1.2747",
  "calling-orchestration-schema": "static-1.34859",
  "sales-views-client-types": "static-1.4042",
  "crm-record-cards-service-types": "static-1.3406",
  "content-media-composition-data-lib": "static-1.11274",
  "content-media-compositions": "static-2.15281",
  "media-bridge-lib": "static-1.18485",
  "trellis-story-utils": "static-1.4270",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5537",
  "FileManagerImages": "static-1.35882",
  "video-components": "static-1.12411",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4281",
  "video-embed": "static-1.34900",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67543",
  "layout-data-lib": "static-1.9241",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6334",
  "commerce-tours-lib": "static-1.5635",
  "growth-onboarding-reliability": "static-1.4837",
  "sales-checkout-service-client": "static-1.3430",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21222",
  "sales-email-signature-service-client": "static-1.3591",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21204",
  "outpost": "static-1.3956",
  "advanced-menus-core": "static-1.14739",
  "advanced-menus-lib": "static-1.11726",
  "ui-memberships-settings-lib": "static-1.33288",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14738",
  "simple-menus-lib": "static-1.16255"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33838",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33843",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1872",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5339",
  "hs-test-utils": "/hs-test-utils/static-1.7750",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11170",
  "I18n": "/I18n/static-7.1555",
  "jasmine-immutable": "/jasmine-immutable/static-1.2767",
  "jasmine-runner": "/jasmine-runner/static-1.6219",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6657",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16387",
  "reporting-data": "/reporting-data/static-1.66299",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8232",
  "reporting-visualizations": "/reporting-visualizations/static-1.58375",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4510",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4819",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2230",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.715",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38689",
  "customer-data-objects": "/customer-data-objects/static-1.7386",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7820",
  "data-fetching-client": "/data-fetching-client/static-1.9425",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4280",
  "flux-actions": "/flux-actions/static-1.302",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85161",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4479",
  "foundations-components": "/foundations-components/static-1.7419",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyle": "/HubStyle/static-2.11478",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6909",
  "metrics-js": "/metrics-js/static-1.9346",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3608",
  "property-translator": "/property-translator/static-1.5162",
  "quartz-config": "/quartz-config/static-1.435",
  "quartz-core": "/quartz-core/static-1.5876",
  "quick-fetch": "/quick-fetch/static-1.3684",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5129",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7908",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7839",
  "report-customization-components": "/report-customization-components/static-1.12345",
  "reporting-enablement": "/reporting-enablement/static-1.21892",
  "reporting-reports": "/reporting-reports/static-1.65977",
  "reporting-snowflake": "/reporting-snowflake/static-1.54917",
  "reporting-ui-components": "/reporting-ui-components/static-2.63571",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4378",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8683",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8817",
  "sanitize": "/sanitize/static-1.4223",
  "sanitize-text": "/sanitize-text/static-1.7888",
  "self-service-api": "/self-service-api/static-1.9994",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1498",
  "signup-constants": "/signup-constants/static-1.18283",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20293",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7806",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4520",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10743",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10879",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9295",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17553",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10631",
  "ui-images": "/ui-images/static-2.1076",
  "UIComponents": "/UIComponents/static-3.8117",
  "usage-tracker": "/usage-tracker/static-1.7082",
  "usage-tracker-container": "/usage-tracker-container/static-1.7072",
  "usage-tracker-core": "/usage-tracker-core/static-1.6932",
  "usage-tracker-public": "/usage-tracker-public/static-1.6893",
  "viral-links-lib": "/viral-links-lib/static-1.6773",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3181",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2934",
  "quartz-webpack": "/quartz-webpack/static-1.2881",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8206",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4580",
  "foundations-theming": "/foundations-theming/static-1.4156",
  "quartz-auth": "/quartz-auth/static-1.332",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4768",
  "foundations-theming-base": "/foundations-theming-base/static-1.3141",
  "HeadJS": "/HeadJS/static-2.701",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2861",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4079",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7675",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3451",
  "reporting-client-types": "/reporting-client-types/static-1.2368",
  "hs-story-utils": "/hs-story-utils/static-1.9176",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9348",
  "hubspotter-http": "/hubspotter-http/static-1.4433",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6997",
  "crm-message-bus": "/crm-message-bus/static-1.42191",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21123",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12751",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12888",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9573",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3802",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6522",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6617",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3633",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.717",
  "onboarding-tours": "/onboarding-tours/static-1.16190",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12895",
  "ui-addon-teams": "/ui-addon-teams/static-1.21160",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67468",
  "customer-data-properties": "/customer-data-properties/static-1.50608",
  "forms-ai-lib": "/forms-ai-lib/static-1.3934",
  "forms-utils-lib": "/forms-utils-lib/static-1.12070",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4902",
  "react-dnd-compat": "/react-dnd-compat/static-1.4372",
  "react-tinymce": "/react-tinymce/static-1.54483",
  "tinymce-config": "/tinymce-config/static-2.53609",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10095",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3689",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1059",
  "ui-fonts": "/ui-fonts/static-1.432",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.783",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.474",
  "quartz-head": "/quartz-head/static-1.322",
  "quartz-i18n": "/quartz-i18n/static-1.332",
  "quartz-routing": "/quartz-routing/static-1.87",
  "quartz-test": "/quartz-test/static-1.332",
  "batch-promise": "/batch-promise/static-1.1294",
  "external-options-client-types": "/external-options-client-types/static-1.3938",
  "react-colorpicker": "/react-colorpicker/static-2.9960",
  "copilot-toolkit": "/copilot-toolkit/static-1.10392",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12197",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40493",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1005",
  "reporting-plugins": "/reporting-plugins/static-1.9917",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4002",
  "ui-addon-opt": "/ui-addon-opt/static-4.8136",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9892",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24572",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4628",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3948",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8770",
  "merchandise-lib": "/merchandise-lib/static-1.256",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5391",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3859",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4256",
  "timezone-utils": "/timezone-utils/static-2.4992",
  "bender-build-tools": "/bender-build-tools/static-1.2867",
  "chatspot-core": "/chatspot-core/static-1.20111",
  "chirp-fetch": "/chirp-fetch/static-1.1630",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2639",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9346",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3578",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3919",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3473",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17731",
  "growth-data-modal": "/growth-data-modal/static-1.5099",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2815",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1243",
  "navigation-components": "/navigation-components/static-1.17106",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4404",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.256",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7273",
  "ui-universal-auth": "/ui-universal-auth/static-1.8624",
  "user-context": "/user-context/static-1.4843",
  "cms-field-types": "/cms-field-types/static-1.4555",
  "content-icons-ui": "/content-icons-ui/static-1.2135",
  "integrations-lib": "/integrations-lib/static-1.15250",
  "calling-global-api": "/calling-global-api/static-1.63498",
  "calling-internal-common": "/calling-internal-common/static-1.31040",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64880",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57174",
  "commerce-products-lib": "/commerce-products-lib/static-1.8687",
  "crm-links": "/crm-links/static-1.6000",
  "file-manager-components": "/file-manager-components/static-1.22731",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.417",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4005",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.382",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47800",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3742",
  "property-value-citations": "/property-value-citations/static-1.1222",
  "pulse": "/pulse/static-1.249",
  "smart-property-lib": "/smart-property-lib/static-1.5695",
  "tiered-pricing": "/tiered-pricing/static-1.744",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8785",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19385",
  "tinymce-themes": "/tinymce-themes/static-1.55579",
  "data-token-picker": "/data-token-picker/static-1.15963",
  "hub-http-contrib": "/hub-http-contrib/static-1.2793",
  "interframe": "/interframe/static-3.4540",
  "tinymce-data": "/tinymce-data/static-1.39694",
  "tinymce-plugins": "/tinymce-plugins/static-1.56723",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4961",
  "magpie-lib": "/magpie-lib/static-1.5339",
  "magpie-types": "/magpie-types/static-1.4799",
  "simple-logging-lib": "/simple-logging-lib/static-1.2799",
  "content-assistance-lib": "/content-assistance-lib/static-1.7373",
  "dashboard-lib": "/dashboard-lib/static-1.80399",
  "ExportDialog": "/ExportDialog/static-6.10136",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17455",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17447",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8438",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8124",
  "feedback-loader": "/feedback-loader/static-1.28758",
  "onboarding-scopes": "/onboarding-scopes/static-1.6209",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4397",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.87",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4272",
  "nav-client-types": "/nav-client-types/static-1.2100",
  "purchase-motions-api": "/purchase-motions-api/static-1.5394",
  "trials-service-types": "/trials-service-types/static-1.3673",
  "chatspot-client-types": "/chatspot-client-types/static-1.10412",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.474",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16849",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12665",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5332",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7537",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10121",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31046",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10783",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6287",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.82",
  "customer-data-tracking": "/customer-data-tracking/static-1.6626",
  "products-iframe-lib": "/products-iframe-lib/static-1.7179",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9730",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8390",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3903",
  "video-components-external": "/video-components-external/static-1.10408",
  "video-data-lib": "/video-data-lib/static-1.34066",
  "directed-graph": "/directed-graph/static-1.684",
  "event-emitter": "/event-emitter/static-1.692",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5243",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9431",
  "fsm": "/fsm/static-1.3480",
  "policy-lib": "/policy-lib/static-1.6538",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9494",
  "navigation-messaging": "/navigation-messaging/static-1.6433",
  "FileManagerLib": "/FileManagerLib/static-1.38371",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8852",
  "FileManagerCore": "/FileManagerCore/static-1.38230",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11941",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10916",
  "react-codemirror": "/react-codemirror/static-1.10372",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9638",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13615",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8443",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27800",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8314",
  "payment-link-components": "/payment-link-components/static-1.22786",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23854",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2954",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2747",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34859",
  "sales-views-client-types": "/sales-views-client-types/static-1.4042",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3406",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11274",
  "content-media-compositions": "/content-media-compositions/static-2.15281",
  "media-bridge-lib": "/media-bridge-lib/static-1.18485",
  "trellis-story-utils": "/trellis-story-utils/static-1.4270",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5537",
  "FileManagerImages": "/FileManagerImages/static-1.35882",
  "video-components": "/video-components/static-1.12411",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4281",
  "video-embed": "/video-embed/static-1.34900",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67543",
  "layout-data-lib": "/layout-data-lib/static-1.9241",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6334",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5635",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4837",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3430",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21222",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3591",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21204",
  "outpost": "/outpost/static-1.3956",
  "advanced-menus-core": "/advanced-menus-core/static-1.14739",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11726",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33288",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14738",
  "simple-menus-lib": "/simple-menus-lib/static-1.16255"
}
};
